import React from 'react';

import styles from './styles.module.css';

export default function SettingsHeading({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <div>
      <div className={styles.settingsSectionHeading}>
        <div className={styles.settingsSectionHeadingText}>{title}</div>
        <div className={styles.settingsSectionHeadingLine} />
      </div>
      {!!children && <div className={styles.settingsSectionInfo}>{children}</div>}
    </div>
  );
}
